/* eslint-disable */
const globModules = [
  {
    name: 'homepageMasthead',
    loader: () => import('./modules/homepageMasthead')
  },
  {
    name: 'vimeoVideo',
    loader: () => import('./modules/vimeoVideo')
  },
  {
    name: 'tabbedContentRow',
    loader: () => import('./modules/tabbedContentRow')
  },
  {
    name: 'homepageAnimation',
    loader: () => import('./modules/homepageAnimation')
  },
  {
    name: 'featuredContentRow',
    loader: () => import('./modules/featuredContentRow')
  },
  {
    name: 'bookNow',
    loader: () => import('./modules/bookNow')
  },
  {
    name: 'primaryNavigation',
    loader: () => import('./modules/primaryNavigation')
  },
  {
    name: 'primaryNavigationMobile',
    loader: () => import('./modules/primaryNavigationMobile')
  },
  {
    name: 'accordion',
    loader: () => import('./modules/accordion')
  },
  {
    name: 'timeline',
    loader: () => import('./modules/timeline')
  }
];

export default globModules;
